import React from 'react';
import { Create } from 'react-admin';

import TerritorioForm from '../TerritorioForm';

function TerritorioCreate(props) {
    return (
        <Create {...props}>
            <TerritorioForm />
        </Create>
    );
}

export default TerritorioCreate;
